import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=5c055ab3&scoped=true&"
import script from "./RegisterResult.vue?vue&type=script&lang=js&"
export * from "./RegisterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c055ab3",
  null
  
)

export default component.exports